<div class="card-body">
    <div id="revenue-growth-chart"></div>
</div>